// British English (en-GB)
export default {
  // --- Shell / nav ---
  app_name: 'Tides Near Me',
  search_stations: 'Search stations',
  search_stations_hint: 'Search stations (⌘K)',
  settings: 'Settings',
  app_store: 'Download on the App Store',
  google_play: 'Get it on Google Play',
  app_promo_title: "Download the free app. It's faster 🙂",
  app_promo_body: 'The same tide and current predictions, on your phone.',
  privacy: 'Privacy',
  terms: 'Terms',
  data_sources: 'Data sources',
  support: 'Support',

  guides: 'Guides',
  // --- Home ---
  home_title: 'Find Nearby Tides and Currents',
  by_country: 'By Country',
  favorite_tides: 'Favourite Tides',
  recent_tides: 'Recent Tides',
  nearby_tides: 'Nearby Tides',
  favorite_currents: 'Favourite Currents',
  recent_currents: 'Recent Currents',
  nearby_currents: 'Nearby Currents',
  favorite_charts: 'Favourite Nautical Charts',
  recent_charts: 'Recent Nautical Charts',
  nearby_charts: 'Nearby Nautical Charts',
  finding_stations: 'Finding stations near you…',
  distance_away: '{{distance}} away',

  // --- Search overlay ---
  search_placeholder: 'Search stations…',
  tide_stations: 'Tide Stations',
  current_stations: 'Current Stations',
  recents: 'Recent',
  search_unavailable: 'Search is unavailable right now.',
  no_stations_found: 'No stations found.',
  search_prompt: 'Search tide & current stations by name.',

  // --- Settings ---
  appearance: 'Appearance',
  appearance_system: 'System',
  appearance_light: 'Light',
  appearance_dark: 'Dark',
  tide_height: 'Tide height',
  unit_feet: 'Feet',
  unit_meters: 'Metres',
  distance: 'Distance',
  unit_miles: 'Miles',
  unit_kilometers: 'Kilometres',
  recent_stations: 'Recent stations',
  clear_recents: 'Clear recents',
  currents: 'Currents',
  nautical_charts: 'Nautical charts',
  browse_by_country: 'Browse by country',
  countries_auto: 'Auto',
  countries_always: 'Always',
  countries_never: 'Never',
  show: 'Show',
  hide: 'Hide',

  // --- Station pages (tide + current) ---
  tide_title: '{{name}} Tides',
  current_title: '{{name}} Currents',
  last_tide: 'Last Tide',
  next_tide: 'Next Tide',
  coefficient: 'Coef',
  last_current: 'Last Current',
  next_current: 'Next Current',
  following_current: 'Following Current',
  high: 'High',
  low: 'Low',
  tides: 'Tides',
  sun: 'Sun',
  moon: 'Moon',
  sunrise_now: 'Sunrise',
  sunset_now: 'Sunset',
  moonrise_now: 'Moonrise',
  moonset_now: 'Moonset',
  sunrise_week: 'Rise',
  sunset_week: 'Set',
  moonrise_week: 'Rise',
  moonset_week: 'Set',
  add_to_favorites: 'Add to favourites',
  remove_from_favorites: 'Remove from favourites',

  // --- Week table dates ---
  today: 'Today',
  tomorrow: 'Tomorrow',

  // --- Moon phases ---
  phase_new_moon: 'New Moon',
  phase_waxing_crescent: 'Waxing Crescent',
  phase_first_quarter: 'First Quarter',
  phase_waxing_gibbous: 'Waxing Gibbous',
  phase_full_moon: 'Full Moon',
  phase_waning_gibbous: 'Waning Gibbous',
  phase_last_quarter: 'Last Quarter',
  phase_waning_crescent: 'Waning Crescent',

  // --- Tide / current status vocabulary ---
  rising: 'Rising',
  falling: 'Falling',
  high_tide: 'High Tide',
  low_tide: 'Low Tide',
  ebb: 'Ebb',
  flood: 'Flood',
  slack: 'Slack',

  // --- Relative time (separate singular/plural keys, native-style) ---
  just_now: 'Just now',
  somethings_wrong: "Something's Wrong",
  hour_ago: '{{hour}} hour ago',
  hours_ago: '{{hour}} hours ago',
  minute_ago: '{{minute}} minute ago',
  minutes_ago: '{{minute}} minutes ago',
  hour_minute_ago: '{{hour}} hour, {{minute}} minute ago',
  hour_minutes_ago: '{{hour}} hour, {{minute}} minutes ago',
  hours_minute_ago: '{{hour}} hours, {{minute}} minute ago',
  hours_minutes_ago: '{{hour}} hours, {{minute}} minutes ago',
  hour_from_now: '{{hour}} hour from now',
  hours_from_now: '{{hour}} hours from now',
  minute_from_now: '{{minute}} minute from now',
  minutes_from_now: '{{minute}} minutes from now',
  hour_minute_from_now: '{{hour}} hour, {{minute}} minute from now',
  hour_minutes_from_now: '{{hour}} hour, {{minute}} minutes from now',
  hours_minute_from_now: '{{hour}} hours, {{minute}} minute from now',
  hours_minutes_from_now: '{{hour}} hours, {{minute}} minutes from now',

  // --- Insights ---
  insights_7_day_overview: '7-Day Insights',
  no_insights_available: 'No insights available for this station.',
  insights_current_extremes: 'Current Extremes',
  insights_fastest_flood: 'Fastest Flood',
  insights_fastest_ebb: 'Fastest Ebb',
  insights_strongest_daily_currents: 'Peak Daily Currents',
  insights_fastest_current: 'Fastest',
  insights_slowest_current: 'Slowest',
  insights_tidal_extremes: 'Tidal Extremes',
  insights_highest_tide: 'Highest Tide',
  insights_lowest_tide: 'Lowest Tide',
  insights_strongest_daily_movements: 'Biggest Tidal Ranges',
  insights_largest_tide: 'Largest',
  insights_smallest_tide: 'Smallest',
  insights_value_at_time: '{{value}} at {{time}}',
  insights_tidal_range_label: 'tidal range',
  insights_max_current_label: 'max current',

  // --- Insight bands ---
  band_smaller_than_usual: 'Smaller than usual',
  band_typical: 'Typical',
  band_larger_than_usual: 'Larger than usual',
  band_unusually_large: 'Unusually large',
  band_lower_than_usual: 'Lower than usual',
  band_unusually_low: 'Unusually low',
  band_slower_than_usual: 'Slower than usual',
  band_faster_than_usual: 'Faster than usual',
  band_unusually_fast: 'Unusually fast',
  band_smaller_than_usual_height: 'Lower than usual',
  band_larger_than_usual_height: 'Higher than usual',
  band_unusually_large_height: 'Unusually high',

  // --- Map attribution ---
  attribution: 'Attribution',
  attribution_osm: 'Map data © OpenStreetMap contributors',
  attribution_tiles: 'Map tiles by OpenFreeMap',
  attribution_style: 'Map style © OpenMapTiles',
  ok: 'OK',

  // --- Explore map ---
  current_speed: 'Current Speed',
  depth: 'Depth',
  speed: 'Speed',
  depth_datum: 'Depths from',
  depth_drying: 'Dries',
  depth_loading: 'Loading depth data…',
  depth_datum_tag: 'Depths in {{unit}} below {{datum}}',
  depth_not_for_navigation: 'Not for navigation.',
  depth_unavailable: 'Depth data is unavailable right now.',
  depth_unit_m: 'm',
  depth_unit_ft: 'ft',
  go_mode_start: 'GO',
  go_mode_start_label: 'Start Go Mode',
  go_mode_exit: 'Exit Go Mode',
  go_mode_location_denied: 'Go Mode requires location. Enable it via the lock icon.',
  go_mode_location_denied_ok: 'Okay',
  radar: 'Radar',
  radar_precipitation: 'Precipitation',
  radar_light: 'light',
  radar_moderate: 'moderate',
  radar_heavy: 'heavy',
  radar_storm: 'storm',
  radar_forecast: 'forecast',
  radar_none_for_time: 'no radar for this time',
  now: 'Now',
  explore_prompt_denied:
    'Location is off for this site - enable it via the lock icon in the address bar.',
  open_full_map: 'Open the full map',
  close_full_map: 'Close the full map',
  explore_full_map: 'Explore the full map',
  center_on_location: 'Centre on my location',
  show_my_location: 'Show my location',
  map_knots_label: '{{speed}} kt',

  // --- Location pages ---
  states: 'states',
  no_stations_found_location: 'No stations found.',
  tides_and_currents_by_country: 'Tides & Currents by Country',

  // --- SEO titles / descriptions (templated; {{name}}, {{location}}, etc. are
  // server-supplied place/station data injected at render, not translated) ---
  settings_seo_description: 'Choose your units for tide heights and distances.',
  tide_seo_description: 'Tide predictions, high and low tide times for {{name}}{{location}}.',
  current_seo_description:
    'Tidal current predictions, flood and ebb times for {{name}}{{location}}.',
  location_title: '{{name}} Tides & Currents',
  country_seo_description:
    'Tide times and tidal current predictions for {{name}}. Browse {{stateTerm}} and coastal tide stations across {{name}}.',
  state_seo_description:
    'Tide and current predictions for {{name}}, {{country}}. High and low tide times for coastal stations in {{name}}.',
  city_seo_description:
    'Tide times and tidal current predictions for {{place}}. High and low tides and currents near {{name}}.',
  // --- Chart pages (chart titles, numbers and purposes stay in the
  // issuing authority's language: they name a specific printed sheet) ---
  charts_for_station: 'Nautical Charts for {{name}}',
  chart_intro:
    'Free nautical chart of {{title}}: charted depths, buoys, beacons, rocks, wrecks, marinas, anchorages and live tide stations.',
  chart_page_name: '{{title}} Nautical Chart',
  chart_seo_description:
    'Free nautical chart of {{title}}: charted depths, buoys, beacons, rocks, wrecks, marinas, anchorages and live tide stations.',

  countries_seo_title: 'Tide & Current Stations by Country',
  countries_seo_description:
    'Browse tide and current stations by country. High and low tide times and tidal current forecasts for coastal locations worldwide.',
  home_seo_description:
    'Find tide times and tidal current predictions for coastal stations near you. See high and low tides for your location, or browse stations by country.',
  explore_play: 'Play',
  explore_pause: 'Pause',
  explore_playback_speed: 'Playback speed',
  explore_time: 'Time',
  skip_to_content: 'Skip to main content',
  // --- Weather (station pages) ---
  weather: 'Marine Weather',
  wind: 'Wind',
  gusts: 'Gusts',
  seas: 'Seas',
  time: 'Time',
  air_temp: 'Air',
  water_temp: 'Water',
  water_temperature: 'Water Temperature',
  humidity: 'Humidity',
  pressure: 'Pressure',
  precip_chance: 'Precipitation',
  chances: 'Chances',
  precip_rate: 'Precip rate',
  visibility: 'Visibility',
  condition_thunderstorms: 'Thunderstorms',
  condition_freezing_rain: 'Freezing rain',
  condition_sleet: 'Sleet',
  condition_snow: 'Snow',
  condition_fog: 'Fog',
  condition_rain: 'Rain',
  condition_cloudy: 'Cloudy',
  condition_partly_cloudy: 'Partly cloudy',
  condition_clear: 'Clear',
  weather_thunder: 'Thunder',
  note_seas_computed_from_wind: 'Sea heights are estimated from wind and coastline.',
  note_seas_from_nearby_open_water: 'Sea state is taken from nearby open water.',
  note_seas_open_water_nearby:
    'Waves on the open water nearby are about {{height}}. It could be calmer here.',
  note_seas_open_water_distant:
    'Waves on open water {{distance}} away are about {{height}}. It could be calmer here.',
  note_seas_open_water_distant_dir:
    'Waves on open water {{distance}} {{direction}} of here are about {{height}}. It could be calmer here.',
  note_seas_unavailable: 'No reliable sea state is available for this point.',
  note_sheltered_water_sees_less: 'Sheltered water usually sees less than these open-water values.',
  note_no_warning_feed_coverage: 'No official marine warning feed covers this point.',
  note_nearest_point_across_land: 'The nearest forecast point is across land.',
  warnings_none_active: 'No marine warnings in effect',
  warnings_unavailable: 'Marine warnings are not available for this location',
  warning_show_text: 'Show official text',
  warning_hide_text: 'Hide official text',
  weather_updated: 'Updated {{time}}',
  current_conditions: 'Current conditions',
  daily_forecast: 'Daily forecast',
  expand_for_hourly: 'Expand for hourly',
  hourly: 'Hourly',
  hourly_forecast: 'Hourly forecast',
  wind_speed: 'Wind speed',
  wind_gusts: 'Wind & gusts',
  pressure_humidity: 'Pressure & humidity',
  max_seas: 'Max seas',
  visibility_excellent: 'Excellent',
  visibility_good: 'Good',
  visibility_moderate: 'Moderate',
  visibility_poor: 'Poor',
  forecaster_text_link: '{{issuer}} forecast text',
  temperature: 'Temperature',
  unit_fahrenheit: 'Fahrenheit',
  unit_celsius: 'Celsius',
  // --- Conditions summary (station pages) ---
  // Sea state: WMO Sea State Code. Wind: Beaufort. Both are published
  // scales with standard terminology in each language, not our own wording.
  // Warning-window and low–high range punctuation. CJK marks a range (and
  // an open end) with ～, not an en dash or a trailing plus.
  warning_window_range: '{{start}} – {{end}}',
  warning_window_open: '{{start}}+',
  range_separator_short: '-',
  // Wave-period fragments. The connector is the locale's own word for the
  // "at" in "0.5 m S @ 3s" (CJK says "period" instead); the value carries
  // the locale's seconds notation (秒/초 — bare Latin "s" reads as an
  // untranslated fragment in CJK weather products).
  seas_period_at: '@',
  wave_period_short: '{{period}}s',
  // 16-point compass, per this locale’s meteorological convention — the
  // letters differ across languages (Z/O/Ø/V…) and CJK writes the words out.
  compass_N: 'N',
  compass_NNE: 'NNE',
  compass_NE: 'NE',
  compass_ENE: 'ENE',
  compass_E: 'E',
  compass_ESE: 'ESE',
  compass_SE: 'SE',
  compass_SSE: 'SSE',
  compass_S: 'S',
  compass_SSW: 'SSW',
  compass_SW: 'SW',
  compass_WSW: 'WSW',
  compass_W: 'W',
  compass_WNW: 'WNW',
  compass_NW: 'NW',
  compass_NNW: 'NNW',
  // Known warning types, one badge label each. Bureau-home locales use the
  // bureau’s official terminology. Unknown types fall back to the humanized
  // English code in every locale (see warningTypeLabel).
  warning_type_small_craft_advisory: 'Small craft advisory',
  warning_type_gale_warning: 'Gale warning',
  warning_type_gale_watch: 'Gale watch',
  warning_type_storm_warning: 'Storm warning',
  warning_type_storm_watch: 'Storm watch',
  warning_type_hurricane_force_wind_warning: 'Hurricane force wind warning',
  warning_type_hurricane_force_wind_watch: 'Hurricane force wind watch',
  warning_type_special_marine_warning: 'Special marine warning',
  warning_type_marine_weather_statement: 'Marine weather statement',
  warning_type_hazardous_seas_warning: 'Hazardous seas warning',
  warning_type_brisk_wind_advisory: 'Brisk wind advisory',
  warning_type_low_water_advisory: 'Low water advisory',
  warning_type_dense_fog_advisory: 'Dense fog advisory',
  warning_type_heavy_freezing_spray_warning: 'Heavy freezing spray warning',
  warning_type_strong_wind_warning: 'Strong wind warning',
  warning_type_gale_force_wind_warning: 'Gale force wind warning',
  warning_type_storm_force_wind_warning: 'Storm force wind warning',
  warning_type_wind_warning: 'Wind warning',
  warning_type_dense_fog_warning: 'Dense fog warning',
  warning_type_icing_warning: 'Icing warning',
  warning_type_typhoon_warning: 'Typhoon warning',
  warning_type_wind_wave_warning: 'Wind wave warning',
  warning_type_wind_wave_advisory: 'Wind wave advisory',
  warning_type_strong_wind_advisory: 'Strong wind advisory',
  warning_type_storm_surge_warning: 'Storm surge warning',
  warning_type_storm_surge_advisory: 'Storm surge advisory',
  warning_type_thunderstorm_warning: 'Thunderstorm warning',
  warning_type_rough_sea_warning: 'Rough sea warning',
  warning_type_fog_warning: 'Fog warning',
  sea_state_calm_rippled: 'Rippled water',
  sea_state_smooth: 'Smooth water',
  sea_state_slight: 'Slight seas',
  sea_state_moderate: 'Moderate seas',
  sea_state_rough: 'Rough seas',
  sea_state_very_rough: 'Very rough seas',
  sea_state_high: 'High seas',
  sea_state_very_high: 'Very high seas',
  sea_state_phenomenal: 'Phenomenal seas',
  hazard_showers: 'Showers',
  hazard_reduced_visibility: 'Reduced visibility',
  hazard_haze: 'Haze',
  hazard_waterspout: 'Waterspouts',
  hazard_freezing_spray: 'Freezing spray',
  hazard_ice: 'Ice',
  marine_summary_sea_wind: '{{sea}}, {{direction}} wind at {{speed}}.',
  marine_summary_wind_only_gusting: '{{direction}} wind at {{speed}} with gusts to {{gust}}.',
  marine_summary_sea_wind_gusting:
    '{{sea}}, {{direction}} wind at {{speed}} with gusts to {{gust}}.',
  marine_summary_wind_only: '{{direction}} wind at {{speed}}.',
  marine_summary_sea_only: '{{sea}}.',
  marine_prediction_caveat_tide_one:
    'Tide predictions are astronomical, so the weather in that warning can raise or lower the actual level.',
  marine_prediction_caveat_tide_many:
    'Tide predictions are astronomical, so the weather in those warnings can raise or lower the actual level.',
  marine_prediction_caveat_current_one:
    'Current predictions are astronomical, so the weather in that warning can strengthen or weaken the actual flow.',
  marine_prediction_caveat_current_many:
    'Current predictions are astronomical, so the weather in those warnings can strengthen or weaken the actual flow.',
  marine_warning_active: 'A marine warning is in force for this area.',
  marine_warnings_active: 'Marine warnings are in force for this area.',
  marine_warning_upcoming: 'A marine warning for this area takes effect {{time}}.',
  marine_warnings_upcoming: 'Marine warnings for this area take effect from {{time}}.',
  marine_summary_hazard_now: '{{hazard}} right now.',
  marine_summary_hazard_later: '{{hazard}} in the forecast.',
  marine_tide_rising: 'The tide is {{height}} and rising: next high {{next}} at {{time}}.',
  marine_tide_falling: 'The tide is {{height}} and falling: next low {{next}} at {{time}}.',
  marine_current_flood: 'Next flood {{speed}} at {{time}}.',
  marine_current_ebb: 'Next ebb {{speed}} at {{time}}.',
  marine_current_slack: 'Next slack water at {{time}}.',
  marine_current_now_flood: 'The current is flooding at {{speed}}.',
  marine_current_now_ebb: 'The current is ebbing at {{speed}}.',
  marine_current_now_slack: 'The current is slack.',
  marine_current_peak: 'Peaking at {{speed}} at {{time}}.',

  // --- Chart furniture (navaid / hazard / POI click popups) ---
  // See en.js for the rules these follow. "IALA A" / "IALA B" stay untranslated
  // in every language: it is the standard's name.
  furn_light: 'Light',
  furn_buoy: 'Buoy',
  furn_beacon: 'Beacon',
  furn_wreck: 'Wreck',
  furn_rock: 'Rock',
  furn_obstruction: 'Obstruction',
  furn_anchorage: 'Anchorage',
  furn_tss: 'Traffic separation scheme',
  furn_routing: 'Routing',
  furn_title_buoy: '{{category}} buoy',
  furn_title_beacon: '{{category}} beacon',
  furn_cat_port: 'Port',
  furn_cat_starboard: 'Starboard',
  furn_cat_preferred_channel_port: 'Preferred-channel port',
  furn_cat_preferred_channel_starboard: 'Preferred-channel starboard',
  furn_cat_safe_water: 'Safe water',
  furn_cat_isolated_danger: 'Isolated danger',
  furn_cat_north: 'North',
  furn_cat_east: 'East',
  furn_cat_south: 'South',
  furn_cat_west: 'West',
  furn_cat_special: 'Special',
  furn_cat_mooring: 'Mooring',
  furn_cat_lateral: 'Lateral',
  furn_characteristic: 'Characteristic',
  furn_range: 'Range',
  furn_height: 'Height',
  furn_colour: 'Colour',
  furn_shape: 'Shape',
  furn_lights_on_mark: 'Lights on this mark',
  furn_topmark: 'Topmark',
  furn_class: 'Class',
  furn_least_depth_over: 'Least depth over',
  furn_depth_over: 'Depth over',
  furn_state: 'State',
  furn_type: 'Type',
  furn_range_value: '{{value}} M',
  furn_metres_value: '{{value}} m',
  furn_cable: 'Submarine cable',
  furn_pipeline: 'Pipeline',
  furn_restricted_area: 'Restricted area',
  furn_restriction: 'Restriction',
  furn_mpa: 'Marine protected area',
  furn_protection: 'Protection',
  furn_agency: 'Managed by',
  furn_mpa_note: 'A conservation designation, not a navigation restriction.',
  furn_sector: 'Sector',
  furn_sector_value: '{{from}}° → {{to}}°',
  lightw_f: 'Steady {{colour}} light.',
  lightw_fl: 'Flashes {{colour}} every {{period}} seconds.',
  lightw_fl_group: 'Flashes {{colour}} in groups of {{count}}, every {{period}} seconds.',
  lightw_lfl: 'A long {{colour}} flash every {{period}} seconds.',
  lightw_q: 'Rapid {{colour}} flashing.',
  lightw_iso: 'Equal {{colour}} light and dark, every {{period}} seconds.',
  lightw_oc: 'Steady {{colour}} with a brief dark interval every {{period}} seconds.',
  lightcolour_white: 'white',
  lightcolour_red: 'red',
  lightcolour_green: 'green',
  lightcolour_yellow: 'yellow',
  furn_feet_charted_value: '{{feet}} ft ({{metres}} m charted)',
  furn_light_yes: 'yes',
  furn_shown_neutral: '{{colours}} (shown neutral)',
  furn_note_light: 'How the light appears at night: a mariner identifies it by this.',
  furn_note_lateral_b_port:
    'Marks the LEFT side of the channel returning from sea (IALA B: green can).',
  furn_note_lateral_b_starboard:
    'Marks the RIGHT side of the channel returning from sea (IALA B: “red right returning”).',
  furn_note_lateral_a_port:
    'Marks the PORT side of the channel entering from sea (IALA A: red to port).',
  furn_note_lateral_a_starboard:
    'Marks the STARBOARD side of the channel entering from sea (IALA A: green to starboard).',
  furn_note_safe_water: 'Safe water all round, typically the landfall or mid-channel mark.',
  furn_note_isolated_danger: 'Moored over an isolated danger with navigable water around it.',
  furn_note_cardinal_north: 'Cardinal mark: pass to the NORTH of it.',
  furn_note_cardinal_east: 'Cardinal mark: pass to the EAST of it.',
  furn_note_cardinal_south: 'Cardinal mark: pass to the SOUTH of it.',
  furn_note_cardinal_west: 'Cardinal mark: pass to the WEST of it.',
  furn_note_special: 'Special-purpose mark (yellow): limits, cables, moorings, racing.',
  furn_note_preferred_starboard: 'Junction mark: the preferred channel lies to starboard.',
  furn_note_preferred_port: 'Junction mark: the preferred channel lies to port.',
  furn_note_mooring: 'Mooring buoy.',
  furn_vessel: 'Vessel',
  furn_depth_quality: 'Depth quality',
  furn_length: 'Length',
  furn_position_accuracy: 'Position accuracy',
  furn_remarks: 'Remarks',
  furn_circumstances: 'Circumstances',
  furn_status: 'Status',
  furn_note_shom: 'Charted by Shom (France). ©Shom, CC BY-SA 4.0.',
  furn_lock: 'Lock',
  furn_bridge: 'Bridge',
  furn_overhead_cable: 'Overhead cable',
  furn_notice_mark: 'Notice mark',
  furn_distance_mark: 'Distance mark',
  furn_daymark: 'Daymark',
  furn_channel: 'Channel',
  furn_vertical_clearance_closed: 'Vertical clearance (closed)',
  furn_vertical_clearance_open: 'Vertical clearance (open)',
  furn_datum: 'Datum',
  furn_datum_value: '{plane} (VERDAT {code})',
  furn_datum_unknown: 'unknown code (VERDAT {code})',
  furn_note_ienc:
    'Inland ENC (US Army Corps of Engineers). Clearances are heights above the reference plane named above, so real headroom is less when the river is up.',
  furn_note_wreck: 'Charted wreck. Depths are charted values, not verified.',
  furn_note_anchorage: 'Charted anchorage area.',
  furn_note_tss: 'One-way shipping lanes. Small craft cross at right angles and keep clear.',
  furn_route: 'Route',
  furn_fairway: 'Fairway',
  furn_recommended_track: 'Recommended track',
  furn_navigation_line: 'Navigation line',
  furn_leading_line: 'Leading line',
  furn_clearing_line: 'Clearing line',
  furn_transit_line: 'Transit line',
  furn_traffic: 'Traffic',
  furn_orientation: 'Orientation',
  furn_degrees_value: '{{value}}°',
  furn_note_fairway: 'Charted fairway: the maintained or preferred channel.',
  furn_note_track: 'Charted course line.',
  furn_note_track_fixed_marks: 'Charted course line, based on fixed marks (transits).',
  furn_note_leading_line: 'Keep the transit marks aligned to stay on the charted line.',
  furn_note_navigation_line: 'Charted navigation line.',
  furn_poi_marina: 'Marina',
  furn_poi_fuel: 'Fuel',
  furn_poi_slipway: 'Slipway',
  furn_poi_ferry_terminal: 'Ferry terminal',
  furn_poi_boatyard: 'Boatyard',
  furn_poi_lighthouse: 'Lighthouse',
  furn_note_slipway: 'Launching ramp.',
  // Layers sheet — UNTRANSLATED, English placeholders (2026-09-11). Catalog
  // parity is enforced by scripts/check-locale-keys.mjs, so a key cannot be
  // added to en.js alone; these are placeholders awaiting translation, not
  // a claim that the strings are localized.
  layers: 'Layers',
  layers_close: 'Close layers',
  layers_map_type: 'Map type',
  layers_visualizations: 'Visualizations',
  layers_standard_map: 'Standard Map',
  layers_depth_chart: 'Depth Chart',
  layers_moving_tides: 'Moving Tides',
  layers_moving_currents: 'Moving Currents',
  layers_wind_waves: 'Wind & Waves',
  layers_weather_radar: 'Weather Radar',
  layers_coming_soon: 'Coming soon',
  layers_no_currents_here: 'No current stations in view',
  layers_no_radar_here: 'No radar coverage in view',
  // The compass button's accessible name. {{point}} is a 16-point direction
  // (SSW) and {{deg}} the exact bearing — the face rounds to 8 points, this
  // does not. English placeholder in the non-English catalogs, awaiting
  // translation; catalog parity is enforced by scripts/check-locale-keys.mjs.
  follow_my_direction: 'Follow my direction',
  compass_faces: 'Map faces {{point}} · {{deg}}°, tap for north-up',
  ww_row_no_data: '{{row}}: no data here',
  ww_row_no_forecast_after: '{{row}}: no forecast after {{when}}',
  ww_row_no_forecast: '{{row}}: no forecast this far ahead',
  ww_unavailable: 'Weather unavailable',
  explore_show_player: 'Show the timeline',
  explore_hide_player: 'Hide the timeline',

  // --- Route planning on /explore (see en.js for the wording rules; the
  // service's disclaimer is shown verbatim, route_disclaimer is only the
  // fallback). British usage: draught, beacon. ---
  route_plan: 'Plan a route',
  route_leave: 'Leave route planning',
  route_title: 'Route',
  route_prompt_start: "Tap the water where you'll start.",
  route_prompt_start_desktop: "Click the water where you'll start, then click your destination.",
  route_prompt_end: 'Start set. Now tap your destination.',
  route_prompt_end_desktop: 'Start set. Now click your destination.',
  route_drag_hint: 'Pins can be dragged.',
  route_clear: 'Clear',
  route_swap: 'Swap start and destination',
  route_share: 'Copy link',
  route_copied: 'Link copied',
  route_start: 'Start',
  route_destination: 'Destination',
  route_near: 'near {{name}}',
  route_loading: 'Plotting your route…',
  route_loading_sub: 'Usually a second or two. Some areas take up to 30 seconds.',
  route_loading_slow: 'Still working…',
  route_loading_slow_sub: 'This area is taking longer than usual.',
  route_summary_time: '{{duration}} at {{speed}}',
  route_planning_speed: 'Planning speed',
  route_shoalest: 'Shallowest on route',
  route_planning_draft: 'planning draught',
  route_change: 'change',
  route_draft_title: 'Planning draught',
  route_draft_help:
    "The depth the route is planned for, not your boat's draught. Deeper finds fewer ways; shallower finds more.",
  route_datum: 'Depths at chart datum (MLLW), no tide applied.',
  route_unassured_note:
    'Orange stretches cross water the chart and survey do not resolve below {{draft}}.',
  route_row_start: 'Start {{label}}',
  route_row_heading: 'head {{course}}° ({{point}})',
  route_row_end: 'Arrive {{label}}',
  route_row_end_sub: 'end of route',
  route_turn_left: 'Turn left to {{course}}°',
  route_turn_right: 'Turn right to {{course}}°',
  route_bear_left: 'Bear left to {{course}}°',
  route_bear_right: 'Bear right to {{course}}°',
  route_then: '{{first}}, then {{second}}',
  route_keep_mark: 'Keep {{mark}} on your {{hand}}',
  route_leave_channel: 'Leave the channel at {{mark}}',
  route_on_your: 'on your {{hand}} ({{side}})',
  route_hand_left: 'left',
  route_hand_right: 'right',
  route_side_port: 'port',
  route_side_starboard: 'starboard',
  route_mark_buoy: '{{color}} buoy {{num}}',
  route_mark_light: '{{color}} light {{num}}',
  route_mark_daybeacon: '{{color}} beacon {{num}}',
  route_mark_lighted: '{{mark}} (lighted)',
  route_red: 'red',
  route_green: 'green',
  route_follow: 'Follow {{name}}',
  route_follow_two: 'Follow {{first}}, then {{second}}',
  route_follow_channel: 'the {{name}} channel',
  route_follow_named: 'the {{name}}',
  route_follow_unnamed: 'the marked channel',
  route_follow_marks: '{{count}} marks',
  route_greens_on: 'greens on your {{hand}}',
  route_reds_on: 'reds on your {{hand}}',
  route_show_marks: 'Show marks',
  route_hide_marks: 'Hide marks',
  route_why: 'Why does it turn here?',
  route_turn_reason: 'Turns here because {{reason}}',
  route_lights: 'Lights in range: {{lights}}',
  route_stretch_unassured: 'depth not resolved below {{draft}}',
  route_stretch_rocky: 'between charted rocks',
  route_stretch_canal: 'canal: lock operation, gates and bridge clearance not modelled',
  route_step_of: 'Step {{n}} of {{total}}',
  route_all_steps: 'All steps',
  route_prev_step: 'Previous step',
  route_next_step: 'Next step',
  route_minutes: '{{n}} min',
  route_hours: '{{h}} h',
  route_hours_minutes: '{{h}} h {{m}} min',
  route_err_on_land_origin: 'Your start is on charted land',
  route_err_on_land_destination: 'Your destination is on charted land',
  route_err_on_land_origin_sub:
    'Drag the start pin into the water. A marsh, a beach or a pier counts as land on the chart.',
  route_err_on_land_destination_sub:
    'Drag the destination pin into the water. A marsh, a beach or a pier counts as land on the chart.',
  route_err_no_route: 'No route at a {{draft}} planning draught',
  route_err_no_route_sub:
    'Somewhere between the two points the chart is shallower than {{draft}}. A smaller planning draught may find a way.',
  route_err_no_snap: 'No charted water near one of the points',
  route_err_no_snap_sub: 'Move the pins closer to open water.',
  route_err_outside: 'Route planning covers US waters for now',
  route_err_outside_sub:
    'Routes are built from NOAA charts, so both points need to be in US waters. More coasts later.',
  route_err_timeout: 'The route service took too long',
  route_err_timeout_sub: 'Some areas take up to 30 seconds and this one ran out of time.',
  route_err_unavailable: "Route planning isn't available right now",
  route_err_unavailable_sub: 'Try again in a moment.',
  route_err_busy: 'Too many route requests',
  route_err_busy_sub: 'Wait a minute and try again.',
  route_try_again: 'Try again',
  route_disclaimer:
    'Not for navigation. This route follows the marked channel as charted; it is not a claim of safe water.',
  route_promo_title: 'Follow this route in the app with Go Mode',
  route_promo_body:
    "Go Mode keeps your boat on the chart with the distance to the next mark or turn, the depth under you, and the nearest station's tide and current. In Tides Near Me for iPhone and Android, with a subscription.",
}
